import { Card } from "@mui/material";

import PropTypes from "prop-types";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useDispatch } from "react-redux";

import { updateAppHost } from "../redux/features/app/appSlice";
import MDTypography from "../components/MDTypography";
import MDBox from "../components/MDBox";
import MDButton from "../components/MDButton";
import constants from "../common/constants";

var errorList = [
  {
    code: "401",
    title: "401 Unauthorised",
    message: "Apologies, you do not have access to this page.",
  },
  {
    code: "403",
    title: "403 Forbidden",
    message: "Apologies, you do not have access to this page.",
  },
  {
    code: "404",
    title: "404 Page Not Found",
    message: "Apologies, the page you are looking for cannot be found.",
  },
];

/**
 *
 * @param {variant} {@errorList}
 *   {
    code: "401",
    title: "401 Unauthorised",
    message: "Apologies, you do not have access to this page.",
  },
  {
    code: "403",
    title: "403 Forbidden",
    message: "Apologies, you do not have access to this page.",
  },
  {
    code: "404",
    title: "404 Page Not Found",
    message: "Apologies, the page you are looking for cannot be found.",
  },
 * @returns
 */
const ErrorComponent = ({ variant, loginAppHost, showLogin }) => {
  const dispatch = useDispatch();
  return (
    <Card>
      <MDBox pt={5} pb={5} mt={1} mb={20} px={3}>
        <MDTypography variant="h1">{errorList[variant].title}</MDTypography>
        <br />
        <MDTypography variant="body">{errorList[variant].message}</MDTypography>
        <br />
        {showLogin && (
          <MDButton
            sx={{ marginTop: "2em" }}
            variant="outlined"
            onClick={() => {
              dispatch(updateAppHost(loginAppHost));
              window.location.href = constants.domain + "login";
            }}
            color="info"
          >
            Log In
            <ArrowForwardIcon
              sx={{
                marginLeft: "3px",
                marginTop: "auto",
                marginBottom: "auto",
              }}
            />
          </MDButton>
        )}
      </MDBox>
    </Card>
  );
};

ErrorComponent.defaultProps = {
  loginAppHost: "JMM",
  showLogin: true,
  variant: 1,
};
ErrorComponent.propTypes = {
  variant: PropTypes.number.isRequired,
};

export default ErrorComponent;
